<template>
  <span
    v-if="encrypted"
    class="mx-1 bg-blue-lighter"
  >
    <span
      v-for="key in length"
      :key="key"
    >X</span>
  </span>
  <span
    v-else
    class="mx-1"
  >{{ text }}</span>
</template>

<script>
export default {
  name: 'TerminalHiddenWord',

  props: {
    text: {
      type: String,
      default: ' ',
    },

    encrypted: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    length() {
      return this.text.length
    },
  },
}
</script>
